import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { APP_NAME } from '../../utils/app.constants';
import { ThemeService } from '../../services/theme.service';
import { UserManagementService } from '../../services/user-management.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  appName: string = APP_NAME;
  sideBarWidth = 230;
  isMarketOverview = false;
  headerLogoURL!: string;
  orgId!: string;

  constructor(
    private router: Router,
    public themeService: ThemeService,
    private userManagementService: UserManagementService,
  ) {
    this.isMarketOverview = this.router.url.startsWith('/market-overview');
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.isMarketOverview = (event as NavigationEnd).urlAfterRedirects.startsWith('/market-overview');
    });
    this.orgId = this.userManagementService.getOrgId();
    this.headerLogoURL = `/assets/images/logos/${this.orgId}.png`;
  }
}
